import * as EventUtil from "../common/eventUtil";
import * as Global from "../common/global";
import { TargetEditControl } from "../common/targetEdit";
import { IController } from "../interfaces/controller";

export class TargetController implements IController {
    private targetEditControl: TargetEditControl;
    private isNewTarget: boolean;
    private targetTemplateURLName: string;

    constructor() {
        this.targetEditControl = new TargetEditControl();
    }

    public render(container: JQuery): JQueryPromise<any> {
        return this.targetEditControl.render(container.find("div[data-id='targetEditControl']"));
    }

    public load(params: any[]): JQueryPromise<any> {
        if (params == null || params.length < 1 || params.length > 2) {
            // invalid parameters passed into this page
            Global.app().pageManager().closeCurrentPage();

            const deferred = $.Deferred();
            deferred.resolve();
            return deferred.promise();
        }

        this.targetTemplateURLName = params[0];
        let targetID: number | null = null;
        if (params.length === 2) {
            targetID = params[1] as number;
            this.isNewTarget = false;
        } else {
            this.isNewTarget = true;
        }

        return this.targetEditControl.load(this.targetTemplateURLName, targetID);
    }

    public haveFieldsChanged(): boolean {
        return this.targetEditControl.haveFieldsChanged();
    }

    public appRouterID(params: any[]): string {
        let routerID: string = "Target";
        if (params.length > 0) {
            routerID += "-" + params[0];
        }
        if (params.length > 1) {
            routerID += "-" + params[1];
        } else {
            routerID += "-NEW";
        }
        return routerID;
    }

    public title(): string {
        return "Target";
    }

    public subTitle(): string {
        return this.targetEditControl.subTitle();
    }

    public save(): JQueryPromise<any> {
        const me = this;
        const deferred = $.Deferred();

        this.targetEditControl.save()
            .done((targetMaster) => {
                if (me.isNewTarget) {
                    // added a new record, so update the URL
                    me.updateURL(targetMaster.ID);
                } else {
                    // updating an existing record
                    Global.app().pageManager().refreshCurrentPageTitle();
                }
                deferred.resolve();
            })
            .fail(() => {
                deferred.reject();
            });

        return deferred.promise();
    }

    private updateURL(newID: number): void {
        const routeChange: EventUtil.IRouteChange = {
            appRouterID: this.appRouterID([this.targetTemplateURLName]),
            url: "/Target/" + this.targetTemplateURLName + "/" + newID,
            title: this.title(),
            subTitle: this.subTitle(),
            newAppRouterID: this.appRouterID([this.targetTemplateURLName, newID]),
        };

        Global.app().events().trigger(EventUtil.EVENT_ROUTECHANGE, routeChange);
    }

}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--7!./src/script/controllers/target.ts